<template>
  <AppHeaderDropdown right no-caret>
     <template slot="header">
       {{userName}}
     </template>
    <template slot="header">
     <!-- "img/avatars/onedio.jpg" -->
      <img 
        :src=image
        class="img-avatar"/>
    </template>\
    <template slot="dropdown">
      <!-- <b-dropdown-item><i class="fa fa-picture-o" /> Upload Picture</b-dropdown-item> -->
      <!-- <image-uploader
        :preview="false"
        :className="['fileinput', { 'fileinput--loaded': hasImage }]"
        capture="environment"
        :debug="0"
        doNotResize="gif"
        :autoRotate="true"
        outputFormat="verbose"
        @input="setImage"
      >
       
      </image-uploader> -->
      <b-dropdown-item-button @click="goToSettings" ><i class="fa fa-wrench" />Settings</b-dropdown-item-button>
      <b-dropdown-item-button @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item-button>
     </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import axios from 'axios'
import setProfilePhoto from '../plugins/setProfilePhoto'
import getProfilePhoto from '../plugins/getProfilePhoto'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      userName:'',
      request:false,
      image:'',
      hasImage:false,
    }
  }, 
  methods :{
    goToSettings(){
      this.$router.push('/profile')
    },
    async logout(){
      const initial_state={
      backend: "https://api-dashboard.oned.io",
      backend2: "http://localhost:3000",
      jwtToken: "xImeD2x3EvG4TzNEH68C_7F8MfqkkskBPlSRtrW7F03g2G8_zxmoNiG3BlHuFvwhqPCsy9E2LhpF4tSyFSVV3_-a138qNFtejdPAFaLd5FUZly9NwnJyAjiDZ3vcxJbj6ie8kAFE_kXYbhbv0Slz2XW6bMWeVY6PB_dw1iFXORvEPsXrBAEUzdA-J9HVabZ_WaguVtkkEQxM1jSdJMIr_Z3bV6HJ-XkXncmFJBih92uL0-GWdutR43oOlxKF4tEw54045evMpQrNlkyZqqUTFRX7jKOv-MZkwHz9CBwz107EjgPW4EOgaDMAIp_6OSklzrKWlJs_0PaOwSUHGjOWHw",
      localToken:"amaz1ngda$hboardapikey",
      generalTotal: 0,
      ruble:[],
      dolar:[],
      tl:[],
      allData: {
        chartData: {},
        overviewData: {}
      },
      threeObject: false,
      sevenObject: true,
      fourTeenObject: false,
      thirtyObject: false,
      oneEightyObject: false,
      itemsData: {},
      mainOverviewsData: {},
      labelCurrency:{},
      selectedService:{},
      selectedData: {},
      optionSelectedService: {},
      selectedSites: {},
      request: false,
      comUser:0,
      comPageview:0,
      comSession:0,
      comRate:0,
      coUser:0,
      coPageview:0,
      coSession:0,
      coRate:0,
      ruUser:0,
      ruPageview:0,
      ruSession:0,
      ruRate:0,
      userName:'',
      overview:'',
      date1:'',
      date2:'',
    }
      let inactive=false
     /*  await this.$store.dispatch('SET_BUTTON_ACTIVES',{a: inactive, b: true, c: inactive,d:inactive,e:inactive}) */
      await this.$store.dispatch('RESET',initial_state)
      $cookies.remove('user')
      $cookies.remove('username')
      this.$router.push('/pages/login')
    },
    
  },
  
  /* async beforeCreate () {
  this.request= await this.$store.state.request
  if(this.request){
    this.userName=await this.$cookies.get('username')
    await this.$events.listen('SET_USERNAME', username => {
    this.userName=username
    });
    let image
    await  getProfilePhoto(this.userName).then(im => image=im.data)
    if(!image.status){
      this.image= "https://img-s1.onedio.com/id-5444cbcc11bc55915ecc573e/rev-0/w-500/h-500/f-jpg/s-cae76ad74c28a56b6ecda070d3125bdc45c8e17f.jpg"
        setProfilePhoto(this.userName,this.image)
    }
    else{
        this.image=image.profile_image
    }
    await this.$events.listen('PROFILE_PHOTO', image => {
      this.image=image
    })
  }
  }, */
/*   async created () {
  this.request= await this.$store.state.request
  if(this.request){
    this.userName=await this.$cookies.get('username')
    await this.$events.listen('SET_USERNAME', username => {
    this.userName=username
    });
    let image
    await  getProfilePhoto(this.userName).then(im => image=im.data)
    if(!image.status){
      this.image = "https://img-s1.onedio.com/id-5444cbcc11bc55915ecc573e/rev-0/w-500/h-500/f-jpg/s-cae76ad74c28a56b6ecda070d3125bdc45c8e17f.jpg"
        setProfilePhoto(this.userName,this.image)
    }
    else{
        this.image=image.profile_image
    }
    await this.$events.listen('PROFILE_PHOTO', image => {
      this.image=image
    })
  }
  }, */
 async  mounted(){
    this.request= await this.$store.state.request
    if(this.request){
    this.userName=await this.$cookies.get('username')
    await this.$events.listen('SET_USERNAME', username => {
    this.userName=username
    });
    let image
    await getProfilePhoto(this.userName).then(im => image=im.data)
    if(!image.status){
      this.image = "https://img-s1.onedio.com/id-5444cbcc11bc55915ecc573e/rev-0/w-500/h-500/f-jpg/s-cae76ad74c28a56b6ecda070d3125bdc45c8e17f.jpg"
        setProfilePhoto(this.userName,this.image)
    }
    else{
        this.image=image.profile_image
    }
    await this.$events.listen('PROFILE_PHOTO', image => {
      this.image=image
    })
  }
},
  
}
</script>
<style scoped>
.navbar-nav .nav-link {
    color: #4dbd74;
}
</style>